var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 13.3333C29.3187 13.3333 31.8623 14.3869 33.7377 16.2623C35.613 18.1376 36.6666 20.6812 36.6666 23.3333V35H29.9999V23.3333C29.9999 22.4493 29.6487 21.6014 29.0236 20.9763C28.3985 20.3512 27.5506 20 26.6666 20C25.7825 20 24.9347 20.3512 24.3096 20.9763C23.6844 21.6014 23.3333 22.4493 23.3333 23.3333V35H16.6666V23.3333C16.6666 20.6812 17.7202 18.1376 19.5955 16.2623C21.4709 14.3869 24.0144 13.3333 26.6666 13.3333Z",
    stroke: "#C1C6D7",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 15H3.33325V35H9.99992V15Z",
    stroke: "#C1C6D7",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 9.99999C8.50753 9.99999 9.99992 8.50761 9.99992 6.66666C9.99992 4.82571 8.50753 3.33333 6.66659 3.33333C4.82564 3.33333 3.33325 4.82571 3.33325 6.66666C3.33325 8.50761 4.82564 9.99999 6.66659 9.99999Z",
    stroke: "#C1C6D7",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.625a42afa9e1bde9b7730fcfc6b758c4.svg";
export { ForwardRef as ReactComponent };